type GlyphKind =
  | 'task'
  | 'reward'
  | 'club'
  | 'news'
  | 'trophy'
  | 'account'
  | 'bell'

const KIND_BY_TYPE: Record<string, GlyphKind> = {
  task_completed: 'reward',
  pts_earned: 'reward',
  welcome_bonus: 'reward',
  referral_reward: 'reward',
  quest_activity_completed: 'reward',
  ap_withdrawn: 'reward',
  donation_confirmed: 'reward',
  club_in_top10: 'trophy',
  club_news_published: 'news',
  password_changed: 'account',
  new_device_login: 'account',
  email_code: 'account',
  signup_completed: 'account',
  agent_created: 'account'
}

export function glyphKind(type: string): GlyphKind {
  if (KIND_BY_TYPE[type]) {
    return KIND_BY_TYPE[type]
  }
  if (type.startsWith('task_') || type.endsWith('_task_available')) {
    return 'task'
  }
  if (type === 'reservation_expired') {
    return 'task'
  }
  if (type.startsWith('club_')) {
    return 'club'
  }
  return 'bell'
}

const stroke = {
  stroke: 'currentColor',
  strokeWidth: 1.4,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  fill: 'none'
}

const PATHS: Record<GlyphKind, React.ReactNode> = {
  task: (
    <>
      <rect x="3" y="2.5" width="10" height="11" rx="2" {...stroke} />
      <path d="m5.8 8.2 1.5 1.5 3-3.2" {...stroke} />
    </>
  ),
  reward: (
    <path
      d="m8 2.3 1.7 3.5 3.8.55-2.75 2.7.65 3.8L8 11.05l-3.4 1.8.65-3.8L2.5 6.35l3.8-.55L8 2.3Z"
      {...stroke}
    />
  ),
  club: (
    <path
      d="M8 2.2 12.8 4v3.6c0 3-2 5.1-4.8 6.2-2.8-1.1-4.8-3.2-4.8-6.2V4L8 2.2Z"
      {...stroke}
    />
  ),
  news: (
    <>
      <rect x="2.5" y="3" width="11" height="10" rx="1.6" {...stroke} />
      <path d="M5 6h6M5 8.5h6M5 11h3.5" {...stroke} />
    </>
  ),
  trophy: (
    <>
      <path d="M5 2.8h6v3.4a3 3 0 0 1-6 0V2.8Z" {...stroke} />
      <path
        d="M5 4H3.2v.8A2.2 2.2 0 0 0 5.2 7M11 4h1.8v.8A2.2 2.2 0 0 1 10.8 7M8 9.2v2.3M5.6 13.2h4.8"
        {...stroke}
      />
    </>
  ),
  account: (
    <>
      <rect x="3.5" y="7" width="9" height="6.5" rx="1.6" {...stroke} />
      <path d="M5.5 7V5.3a2.5 2.5 0 0 1 5 0V7" {...stroke} />
    </>
  ),
  bell: (
    <>
      <path
        d="M8 2.2a3.7 3.7 0 0 0-3.7 3.7v1.7c0 .4-.16.8-.45 1.07l-.5.48c-.58.57-.24 1.55.56 1.55h8.18c.8 0 1.14-.98.56-1.55l-.5-.48a1.5 1.5 0 0 1-.45-1.07V5.9A3.7 3.7 0 0 0 8 2.2Z"
        {...stroke}
      />
      <path d="M9.7 12.6a1.75 1.75 0 0 1-3.4 0" {...stroke} />
    </>
  )
}

/** A small line icon for the kind of event, so rows can be told apart. */
export function NotificationGlyph({
  type,
  size = 16
}: {
  type?: string
  size?: number
}) {
  const kind = type ? glyphKind(type) : 'bell'

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      aria-hidden
      focusable="false"
      data-glyph={kind}
    >
      {PATHS[kind]}
    </svg>
  )
}
